import { api } from '@api'

interface GetDeliveryNotesResponse {
  sapItemSupplierDeliveryNoteList: string[]
}

const isNotFound = (error: unknown) => {
  if (!error || typeof error !== 'object') return false
  return 'status' in error && (error as { status?: number }).status === 404
}

const getDeliveryNotes = async (documentNumberId?: string, materialId?: number) => {
  if (!documentNumberId) return []

  try {
    const response = await api.get<GetDeliveryNotesResponse>('/sap-item-supplier-delivery-note', {
      params: materialId ? { documentNumberId, materialId } : { documentNumberId },
    })

    return response.data.sapItemSupplierDeliveryNoteList ?? []
  } catch (error) {
    if (isNotFound(error)) return []
    throw error
  }
}

const syncDeliveryNotes = async (documentNumberId: string, materialId: number) => {
  const response = await api.post<GetDeliveryNotesResponse>(
    '/sap-item-supplier-delivery-note/sync',
    {
      documentNumberId,
      materialId,
    },
  )

  return response.data.sapItemSupplierDeliveryNoteList ?? []
}

export const DeliveryNotesApi = { getDeliveryNotes, syncDeliveryNotes }
